const FORM_URLS: Record<string, string> = {
  'Newsletter Signup': 'https://readdy.ai/api/form/d90joa0bhec1he3opk70',
};

export async function get_form_url(name: string): Promise<string> {
  const url = FORM_URLS[name];
  if (!url) {
    throw new Error(`Form "${name}" not found`);
  }
  return url;
}